<template>
  <div class="not-found">
    <div class="content">
      <div class="error-image">
        <i class="el-icon-warning-outline"></i>
      </div>
      <div class="error-code">404</div>
      <div class="error-desc">抱歉，您访问的页面不存在</div>
      <div class="actions">
        <el-button type="primary" @click="goHome">
          <i class="el-icon-s-home"></i> 返回首页
        </el-button>
        <el-button @click="goBack">
          <i class="el-icon-back"></i> 返回上一页
        </el-button>
      </div>
    </div>
    <div class="decoration">
      <i class="el-icon-question decoration-icon d1"></i>
      <i class="el-icon-close decoration-icon d2"></i>
      <i class="el-icon-warning decoration-icon d3"></i>
      <i class="el-icon-error decoration-icon d4"></i>
      <i class="el-icon-remove decoration-icon d5"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/')
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.not-found {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  overflow: hidden;
}

.content {
  text-align: center;
  padding: 20px;
  z-index: 2;
}

.error-image {
  margin-bottom: 20px;
}

.error-image i {
  font-size: 80px;
  color: #E6A23C;
}

.error-code {
  font-size: 120px;
  font-weight: bold;
  color: #409EFF;
  line-height: 1.2;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.error-desc {
  font-size: 24px;
  color: #606266;
  margin-bottom: 30px;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.el-button {
  padding: 12px 24px;
  font-size: 16px;
}

.decoration {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.decoration-icon {
  position: absolute;
  opacity: 0.1;
  color: #606266;
}

.d1 {
  top: 10%;
  left: 15%;
  font-size: 60px;
  animation: float 8s ease-in-out infinite;
}

.d2 {
  top: 20%;
  right: 20%;
  font-size: 45px;
  animation: float 6s ease-in-out infinite;
}

.d3 {
  bottom: 15%;
  left: 25%;
  font-size: 50px;
  animation: float 9s ease-in-out infinite;
}

.d4 {
  bottom: 25%;
  right: 15%;
  font-size: 55px;
  animation: float 7s ease-in-out infinite;
}

.d5 {
  top: 50%;
  left: 80%;
  font-size: 40px;
  animation: float 10s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(5deg);
  }
  100% {
    transform: translateY(0) rotate(0deg);
  }
}
</style>